'use strict';

define(['debounce', 'viewport', '$window'], function (debounce, viewport, $window) {
  var lazyImageLoader = function lazyImageLoader() {
    var module = {};
    var DEBOUNCE_TIMEOUT = 200;
    var VIEWPORT_OFFSET = 360;

    var lazyImages = [];

    /**
     * Main function of the module.
     */
    var _init = function _init() {
      if (document.readyState === 'complete') {
        module.findLazyImages();
        module.lazyLoadAllImages();
      } else {
        $window.addEventListener('load', module.findLazyImages);
        $window.addEventListener('load', module.lazyLoadAllImages);
      }
      $window.addEventListener('scroll', debounce(module.lazyLoadAllImages, DEBOUNCE_TIMEOUT));
      $window.addEventListener('resize', debounce(module.lazyLoadAllImages, DEBOUNCE_TIMEOUT));
    };

    /**
     * This function finds all lazy images that needs to be processed.
     * @returns Array of images to be lazy loaded
     */
    var _findLazyImages = function _findLazyImages() {
      lazyImages = Array.from(document.querySelectorAll('img[data-src], img[data-srcset], source[data-srcset]'));
      return lazyImages;
    };

    /**
     * This function lazy loads simple and responsive images.
     */
    var _lazyLoadAllImages = function _lazyLoadAllImages() {
      module.lazyLoadImages('data-src', 'src');
      module.lazyLoadImages('data-srcset', 'srcset');
    };

    /**
     * More generic way of loading images.
     * It filters all lazy images in the viewport and replaces data-src -> src and data-srcset -> srcset.
     * @param attrToRemove attribute that needs to be removed
     * @param attrToAdd attribute that needs to be added
     * @returns Array of lazy loaded images
     */
    var _lazyLoadImages = function _lazyLoadImages(attrToRemove, attrToAdd) {
      return lazyImages.filter(function (lazyImage) {
        return module.isLazyImageInViewport(lazyImage, attrToRemove);
      }).map(function (lazyImage) {
        return module.changeAttributes(lazyImage, attrToRemove, attrToAdd);
      }).map(function (lazyImage) {
        return module.removeSpinner(lazyImage);
      });
    };

    /**
     * Removes spinner from the image.
     * It filters all lazy images in the viewport and replaces data-src -> src and data-srcset -> srcset.
     * @param lazyImage lazy loaded image
     * @return lazy image
     */
    var _removeSpinner = function _removeSpinner(lazyImage) {
      Array.from(lazyImage.parentNode.childNodes).filter(function (childNode) {
        return typeof childNode.className !== 'undefined';
      }).filter(function (node) {
        return node.className.indexOf('lazyImageLoader_spinner') !== -1;
      }).forEach(function (spinner) {
        return spinner.style.display = 'none';
      });
      return lazyImage;
    };

    /**
     * This function returns true if an elements is in the viewport and has data-srcset and data-src attributes.
     * @param lazyImage image to process
     * @param attr attribute
     * @returns boolean result
     */
    var _isLazyImageInViewport = function _isLazyImageInViewport(lazyImage, attr) {
      return lazyImage.getAttribute(attr) && viewport.isElementVisible(lazyImage, VIEWPORT_OFFSET);
    };

    /**
     * This function changes data-attribute to attribute.
     * @param lazyImage image to process
     * @param attrToRemove attribute that needs to be removed
     * @param attrToAdd attribute that needs to be added
     * @return lazy image
     */
    var _changeAttributes = function _changeAttributes(lazyImage, attrToRemove, attrToAdd) {
      lazyImage[attrToAdd] = lazyImage.getAttribute(attrToRemove);
      lazyImage.removeAttribute(lazyImage, attrToRemove);
      return lazyImage;
    };

    module.changeAttributes = _changeAttributes;
    module.findLazyImages = _findLazyImages;
    module.init = _init;
    module.isLazyImageInViewport = _isLazyImageInViewport;
    module.lazyLoadAllImages = _lazyLoadAllImages;
    module.lazyLoadImages = _lazyLoadImages;
    module.removeSpinner = _removeSpinner;

    // Execute module constructor
    module.init();
    return module;
  };

  // Unit testing access
  return lazyImageLoader();
});
//# sourceMappingURL=lazy-image-loader-esl.js.map
